var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E23237",
    d: "M25.5 7.965 47.838 0l22.926 7.827-3.706 29.54L47.837 48 28.929 37.507z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M70.762 7.827 47.836 0v48l19.22-10.632z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.875 5.611 33.953 36.572l5.195-.104 2.805-6.995h12.433l3.05 7.065 4.949.104zm.035 9.94 4.71 9.835H43.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/Angular.52242445f0e0e5240809227d1c019245.svg";
export { ForwardRef as ReactComponent };